var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        height: "20px",
        width: "20px",
        version: "1.2",
        baseProfile: "tiny",
        id: "_x31_",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "-415 217 128 128",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("path", {
          attrs: {
            d: "M-352.7,270.4c19.8,0,35.9,16.1,35.9,35.9c0,19.8-16.1,35.9-35.9,35.9c-19.8,0-35.9-16.1-35.9-35.9 C-388.6,286.4-372.5,270.4-352.7,270.4z M-373,227.6h4.9v31h-4.9V227.6z M-335.3,227.6h4.9v31h-4.9V227.6z M-353.5,219h4.9v31h-4.9 V219z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }